import { render, staticRenderFns } from "./modalRoom.vue?vue&type=template&id=2e1814d8&scoped=true&"
import script from "./modalRoom.vue?vue&type=script&lang=js&"
export * from "./modalRoom.vue?vue&type=script&lang=js&"
import style0 from "./modalRoom.vue?vue&type=style&index=0&id=2e1814d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1814d8",
  null
  
)

export default component.exports